import { AddressState, TimesheetAddressState } from './address-collection.state';

/**
 * The city for display, with the US state appended when the address carries one — e.g.
 * `'Erlangen'` or `'Malvern, PA'`. Used by the address picker so a US address reads unambiguously
 * without a dedicated state column.
 *
 * @param address the address to format, or `undefined`
 * @returns the formatted city, or `undefined` when the address has no city (including a missing address)
 */
export function cityWithUsState(address?: AddressState | TimesheetAddressState): string | undefined {
    if (!address?.city) {
        return undefined;
    }
    return [address.city, address.stateOfUSA].filter(Boolean).join(', ');
}
